export default __webpack_public_path__ + "static/media/Noimage.2efe78cd.jpg";